import React from 'react';
import {Formik, FieldArray} from 'formik';
import * as css from './TrialSendingPopup.css';
import ContactInputField from './ContactInputField';
import AddContactSection from './AddContactSection';
import {useTrialFormValidation} from '../../hooks/useTrialFormValidation';
import {useTrialFormSubmission} from '../../hooks/useTrialFormSubmission';

interface TrialFormSectionProps {
    contactType: 'phone' | 'email';
    maxContacts?: number;
    namespace?: string;
    onSend: (contacts: string[]) => void;
    onClose: () => void;
    formRef: React.RefObject<any>;
    labels: any;
}

function TrialFormSection({contactType, maxContacts = 3, namespace = 'mailing', onSend, onClose, formRef, labels}: TrialFormSectionProps) {
    const {validationSchema} = useTrialFormValidation({contactType, maxContacts, namespace});
    const {initialValues, onSubmit, handleAddContact} = useTrialFormSubmission({contactType, onSend, onClose});

    return (
        <css.formSection>
            <Formik
                innerRef={formRef}
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
            >
                {({values}) => (
                    <FieldArray
                        name="contacts"
                        render={arrayHelpers => (
                            <>
                                {values.contacts.map((contact, index) => (
                                    <css.inputContainer key={index}>
                                        <ContactInputField
                                            contactType={contactType}
                                            index={index}
                                            label={labels.label}
                                            placeholder={labels.placeholder}
                                        />
                                    </css.inputContainer>
                                ))}
                                <AddContactSection
                                    disabled={values.contacts.length >= maxContacts}
                                    addText={labels.addAnother}
                                    onAddContact={() => handleAddContact(arrayHelpers)}
                                />
                            </>
                        )}
                    />
                )}
            </Formik>
        </css.formSection>
    );
}

export default TrialFormSection;
